export enum ElementAppearance {
    Horizontal = 'horizontal',
    Toolbar = 'toolbar',
    OnBackground = 'onBackground',
    OnWhiteBackground = 'onWhiteBackground',
    NoPadding = 'noPadding',
}
